import { Badge, useThemedValueSwitch } from '@tq/ui-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ConsultationNoteTypes } from 'types';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { CUSTOM_TQ_COLOURS } from 'styles';

export type InternalExternalTagProps = {
  noteType: ConsultationNoteTypes;
};
export const InternalExternalTag: React.FC<InternalExternalTagProps> = ({ noteType }) => {
  const { t } = useTranslation('notes');
  const { tvs } = useThemedValueSwitch();

  const label =
    noteType === 'External' ? t('external', 'External') : t('internal', 'Internal');

  const niStyle = {
    external: {
      bgColor: COLOURS.neutral[7],
      color: COLOURS.black,
    },
    internal: {
      bgColor: COLOURS.neutral[10],
      color: COLOURS.black,
    },
  };

  const tqStyle = {
    external: {
      bgColor: CUSTOM_TQ_COLOURS.blueA0C8DB,
      color: 'black',
    },
    internal: {
      bgColor: 'green.850',
      color: 'white',
    },
  };

  const variant = noteType === 'External' ? 'external' : 'internal';

  return (
    <Badge
      display='flex'
      justifyContent='center'
      fontSize='sm'
      w='96px'
      h='24px'
      bgColor={tvs({ tq: tqStyle[variant].bgColor }, niStyle[variant].bgColor)}
      color={tvs({ tq: tqStyle[variant].color }, niStyle[variant].color)}
    >
      {label}
    </Badge>
  );
};
